module["exports"] = [
  "Leil. ###",
  "Oppgang A",
  "Oppgang B"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/nb_NO/address/secondary_address.js
// module id = 1145
// module chunks = 0